import { emptySplitApi } from './base/emptySplitApi';
import {
  TCreateChatPayload,
  TGetChatHistoryParams,
  TGetChatHistoryResponse,
  TGetChatHistoryListResponse,
  TCreateChatRespose,
  TLoadmoreParams,
  TUpscaleImgResponse,
  TUpscaleImgRequestData,
  TUpscaleImgRequest,
  TOverrideImgResponse,
  TZoomOutRequest,
} from '../utils/types/agrocraftArtisan';
import { createTokenHeader } from '../utils/functions/headers';

export const otpService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['AgrocraftChat'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createChat: builder.mutation<
        TCreateChatRespose,
        TCreateChatPayload
      >({
        query: (params) => ({
          url: 'chat',
          method: 'POST',
          data: params,
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      getChatHistory: builder.query<
        TGetChatHistoryResponse[],
        TGetChatHistoryParams
      >({
        query: (params) => ({
          url: `chat/${params.sessionId}`,
          method: 'GET',
          params: {
            page: 1,
            limit: 100,
          },
        }),
        providesTags: ['AgrocraftChat'],
      }),
      getChatHistoryList: builder.query<
        TGetChatHistoryListResponse[],
        { fetchedForUserId: string | null }
      >({
        query: ({ fetchedForUserId }) => ({
          url: 'chat-session',
          method: 'GET',
          params: {
            fetchedForUserId,
            page: 1,
            limit: 100,
          },
        }),
        providesTags: ['AgrocraftChat'],
      }),
      loadMoreChat: builder.mutation<
        TCreateChatRespose,
        TLoadmoreParams
      >({
        query: ({ chatId, ratio, prompt_style }) => ({
          url: `chat/loadMore/${chatId}`,
          method: 'POST',
          params: {
            ratio,
            prompt_style,
          },
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      imageToPrompt: builder.query<
        { prompt: string },
        FormData
      >({
        query: (data) => ({
          url: 'imageToPrompt',
          method: 'POST',
          data,
          headers: createTokenHeader(),
        }),
      }),
      upscaleImage: builder.mutation<
        TUpscaleImgResponse,
        TUpscaleImgRequestData
      >({
        query: (data) => ({
          url: 'upscaleImage',
          method: 'POST',
          data,
        }),
      }),
      overrideImage: builder.mutation<
        TOverrideImgResponse,
        TUpscaleImgRequest
      >({
        query: ({ chatId, data }) => ({
          url: `upscaleImage/override/${chatId}`,
          method: 'POST',
          data,
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      zoomOut: builder.mutation<void, TZoomOutRequest>({
        query: ({ sessionId, data }) => ({
          url: `outpaint/${sessionId}`,
          method: 'POST',
          data,
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
    }),
  });

export const {
  useCreateChatMutation,
  useGetChatHistoryQuery,
  useGetChatHistoryListQuery,
  useLazyGetChatHistoryListQuery,
  useLoadMoreChatMutation,
  useLazyImageToPromptQuery,
  useUpscaleImageMutation,
  useOverrideImageMutation,
  useZoomOutMutation,
} = otpService;
